export function applyFilters(data, rawFilters) {
    return data.filter((row) =>
        rawFilters.every((f) => {
            if (!f.value) return true;
            const fv = f.value;
            if (fv.gte !== undefined || fv.lte !== undefined) {
                const rowVal = Number(row[f.id] ?? 0);
                if (fv.gte !== undefined && rowVal < fv.gte) return false;
                if (fv.lte !== undefined && rowVal > fv.lte) return false;
                return true;
            }
            const filterVal = fv.value ?? fv;
            if (filterVal === '' || filterVal == null) return true;
            return String(row[f.id] ?? '') === String(filterVal);
        }),
    );
}

export function applySorting(data, sortRules, getComputedValue) {
    if (!sortRules?.length) return data;
    return [...data].sort((a, b) => {
        for (const { field, direction } of sortRules) {
            let aVal = getComputedValue ? getComputedValue(a, field) : undefined;
            let bVal = getComputedValue ? getComputedValue(b, field) : undefined;
            if (aVal === undefined) aVal = a[field];
            if (bVal === undefined) bVal = b[field];
            let cmp;
            if (typeof aVal === 'number' || typeof bVal === 'number') {
                cmp = (aVal ?? 0) - (bVal ?? 0);
            } else {
                cmp = String(aVal ?? '').localeCompare(String(bVal ?? ''));
            }
            if (cmp !== 0) return direction === 'DESC' ? -cmp : cmp;
        }
        return 0;
    });
}

export function paginate(data, page, pageSize) {
    const start = page * pageSize;
    return {
        data: data.slice(start, start + pageSize),
        itemCount: data.length,
    };
}
